angular.module( 'acme.view.application.entities.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.upload',
  'acme.view.application.entities.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var entitiesCreate = {
        name: 'application.entities.create',
        url: '/create/:type',
        views: {
          "subview-main": {
            controller: 'EntitiesCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/entities/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: '  '
        }
      },
      entitiesEdit = {
        name: 'application.entities.edit',
        url: '/edit/:type/:id',
        views: {
          "subview-main": {
            controller: 'EntitiesCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/entities/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: '  '
        }
      };

    $stateProvider
      .state(entitiesCreate)
      .state(entitiesEdit);
});
